import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconCircleNote = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
       <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11.4922" cy="11.4998" r="11" fill={color}/>
            <path d="M7.92076 6.49976C7.13281 6.49976 6.49219 7.17241 6.49219 7.99976V15.4998C6.49219 16.3271 7.13281 16.9998 7.92076 16.9998H12.9208V14.3748C12.9208 13.7537 13.4007 13.2498 13.9922 13.2498H16.4922V7.99976C16.4922 7.17241 15.8516 6.49976 15.0636 6.49976H7.92076ZM16.4922 13.9998H15.481H13.9922C13.7958 13.9998 13.635 14.1685 13.635 14.3748V15.938V16.9998L14.3493 16.2498L15.7779 14.7498L16.4922 13.9998Z"
                  fill="white"/>
        </svg>
    </div>
);

export default IconCircleNote;
